import { useCallback, useRef, useState } from "react";

// derives isReady from the src prop during render so a src change instantly
// flips opacity to 0 within the same commit, with no flicker frame where the
// iframe is visible while loading the new document
const usePreviewIframeReady = ({ src }) => {
  const [isReady, setIsReady] = useState(false);
  const lastSrcRef = useRef(src);

  if (lastSrcRef.current !== src) {
    lastSrcRef.current = src;
    setIsReady(false);
  }

  const handleLoad = useCallback(() => {
    if (!src) return;
    setIsReady(true);
  }, [src]);

  return { isReady, handleLoad };
};

export default usePreviewIframeReady;
